const EMAIL_PATTERN = /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/

const cleanToken = (value) =>
  String(value || '')
    .trim()
    .replace(/^mailto:/i, '')
    .replace(/^(?:[<'"(]|\[)+/, '')
    .replace(/(?:[>'"),]|\])+$/, '')

export const parseOutreachEmailInput = (input) => {
  const emailByNormalizedValue = new Map()
  const invalidEmails = []

  String(input || '')
    .split(/[\s,;]+/)
    .forEach((token) => {
      const email = cleanToken(token)
      if (!email) return

      const normalizedEmail = email.toLowerCase()
      if (email.length > 254 || !EMAIL_PATTERN.test(normalizedEmail)) {
        invalidEmails.push(email)
        return
      }

      if (!emailByNormalizedValue.has(normalizedEmail)) {
        emailByNormalizedValue.set(normalizedEmail, email)
      }
    })

  return {
    emails: [...emailByNormalizedValue.values()],
    invalidEmails: [...new Set(invalidEmails)],
  }
}
